export const handleCopyClick = (data, setIsCopied) => {
  navigator.clipboard.writeText(data);

  setIsCopied(true);
  setTimeout(() => {
    setIsCopied(false);
  }, 2000);
};
